module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_panel) ? _c('section', {
    attrs: {
      "id": "shot-con"
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-guanbicopyx"
    }
  })])]), _vm._v(" "), (_vm.show_loading) ? _c('section', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/5-160914192R5-50.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("正在努力拼图中...")])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "sec"
  }, [_c('img', {
    staticClass: "showPic",
    attrs: {
      "src": _vm.pic_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tip-button"
  }, [_vm._v("长按保存图片")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d85bbc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XShot/XShot.vue
// module id = 524
// module chunks = 1